module.exports = __webpack_public_path__ + "static/media/Colette Curve King Headboard - 180 cm_Teal.7c1615e6.png";